import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthStoreService } from './auth-store.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);
  const token = authStore.token();
  const requestWithAuth = token
    ? request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : request;

  return next(requestWithAuth).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        authStore.clearSession();
        void router.navigate(['/login']);
      }

      return throwError(() => error);
    }),
  );
};
